let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l60f3")).then(() => parcelRequire('2fcAX'));